import React, { useState } from 'react';
import { Icon } from 'semantic';

import { Checkbox, Accordion } from 'semantic-ui-react';

type BaseCheckboxAccordionOption = {
  label: string;
  checked: boolean;
  disabled?: boolean;
};
type CheckboxAccordionOption = BaseCheckboxAccordionOption & {
  [key: string]: any;
};

type CheckboxAccordionProps = {
  title: string;
  options: CheckboxAccordionOption[];
  onChange: (options: CheckboxAccordionOption[]) => void;
};

export function CheckboxAccordion({
  title,
  options = [],
  onChange,
}: CheckboxAccordionProps) {
  const [accordionCollapsed, setAccordionCollapsed] = useState(
    options.some((option) => !option.checked)
  );
  const allOptionsSelected = options.every((option) => option.checked);

  const selectedOptionsCount = options.filter(
    (option) => option.checked
  ).length;

  const intermediateOptionsSelected =
    selectedOptionsCount > 0 && selectedOptionsCount < options.length;

  return (
    <Accordion>
      <Accordion.Title
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Icon
          style={{ marginRight: 10 }}
          name={!accordionCollapsed ? 'angle-right' : 'angle-down'}
          onClick={() => setAccordionCollapsed(!accordionCollapsed)}
        />
        <div style={{ fontWeight: 600 }}>
          <Checkbox
            as="checkbox"
            label={title}
            onChange={(e: any, { checked }) => {
              e.preventDefault();
              const newOptions = options.map((option) => ({
                ...option,
                checked: !!checked,
              }));
              onChange(newOptions);
            }}
            checked={
              intermediateOptionsSelected ? undefined : allOptionsSelected
            }
            indeterminate={intermediateOptionsSelected}
          />
        </div>
      </Accordion.Title>
      <Accordion.Content active={accordionCollapsed}>
        {options.map((option, optionIndex) => {
          return (
            <div
              key={option.label}
              style={{
                paddingLeft: 50,
                fontWeight: 500,
                display: 'flex',
                paddingBottom: 14,
              }}>
              <Checkbox
                label={option.label}
                checked={option.checked}
                disabled={option.disabled}
                onChange={(_, { checked }) => {
                  const newOptions = [...options];
                  newOptions[optionIndex] = { ...option, checked: !!checked };
                  onChange(newOptions);
                }}
              />
            </div>
          );
        })}
      </Accordion.Content>
    </Accordion>
  );
}
